const CategoryManagmentSubRootLevelreduser = (state = [], action) => {
    switch (action.type) {
        case 'GET_SUB_ROOT_LEVEL_CATEGORY_SUCCESS':
            return action.payload.res.data
        default:
            return state
    }
}
export default CategoryManagmentSubRootLevelreduser